<toaster-container [toasterconfig]="toasterconfig"></toaster-container>
<div class="app-body lotas">
    <main class="login d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2 mx-auto">
                    <form [formGroup]="form">
                        <div class="card-group">
                            <div class="card p-4">
                                <div class="card-body">
                                    <div class="text-center mb-4">
                                        <h3>ロータス・リアルタイム実績管理システム</h3>
                                    </div>
                                    <!-- リンクが無効・期限切れのときは依頼画面へ戻す (issue #170) -->
                                    <div *ngIf="expired" class="alert alert-danger">
                                        リンクが無効か期限切れです。<a [routerLink]="['/reset-password']">こちら</a>からもう一度お申し込み下さい。
                                    </div>
                                    <div *ngIf="changed" class="alert alert-success">
                                        パスワードを変更しました。<a [routerLink]="['/login']">ログイン</a>して下さい。
                                    </div>
                                    <div formGroupName="password" *ngIf="!changed">
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label">パスワード</label>
                                            <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(form,newPassword,'password','newPassword')}" tooltip="パスワードは8文字以上である必要があります。" triggers="" #newPassword="bs-tooltip" placement="right">
                                                <input type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'password','newPassword')}" formControlName="newPassword" placeholder="パスワード">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label">パスワード再入力</label>
                                            <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(form,confirmPassword,'password')}" tooltip="パスワードとパスワード再入力が一致しません。" triggers="" #confirmPassword="bs-tooltip" placement="right">
                                                <input type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'password')}" formControlName="confirmPassword" placeholder="パスワード再入力">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="!changed">
                                        <div class="col-12">
                                            <button type="button" class="btn btn-primary btn-block" [disabled]="!form.valid" (click)="changePassword(form.value)">パスワード変更</button>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12">
                                            ログインは<a [routerLink]="['/login']">こちらで</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>
</div>
